/* Raven Performance — dezente Scroll-Reveals + Fahrzeugfinder */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.rv-rev').forEach(function (el) { el.classList.add('rv-in'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rv-in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );
  function observe() {
    document.querySelectorAll('.rv-rev:not(.rv-in)').forEach(function (el) { io.observe(el); });
  }
  observe();
  document.addEventListener('shopify:section:load', observe);
})();
